import formInput from '@/components/forms/input/input.vue';

export default {
  components: {
    formInput,
  },
  data() {
    return {
      search: '',
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/friends-search/friends-search.js